// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"3d23795e","87":"86024b8b","263":"35f97661","372":"0fafc421","476":"ea0f7800","570":"2506639f","787":"5112a2d4","853":"97522201","931":"6450b80f","993":"6a976e83"}[chunkId] + ".chunk.js";
};